// Generated file : do not modify
import Owner from '@/extend/classes/Owner';
import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Compte Bancaire
export default class Rib  {
  // Identifiant unique
  public id: number;
  // ID Banque
  public bankId: number;
  // Code IBAN
  public iban: string;
  // Mandat prélèvement
  public mandatId: number;
  // Owner
  public owner: Owner;
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;
  // Type
  public ownerType: number;
  // Identifiant
  public ownerId: number;
  // Nom
  public ownerLabel: string;

  constructor() {
    this.id = 0;
    this.bankId = 0;
    this.iban = '';
    this.mandatId = 0;
    this.owner = new Owner();
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
    this.ownerType = 0;
    this.ownerId = 0;
    this.ownerLabel = '';
  }

  public static fromJson (obj: Rib): Rib {
    const newRib: Rib = new Rib();
    newRib.id = obj.id;
    newRib.bankId = obj.bankId;
    newRib.iban = obj.iban;
    newRib.mandatId = obj.mandatId;
    newRib.owner = JSON.parse(JSON.stringify(obj.owner));
    newRib.createId = obj.createId;
    newRib.failed = obj.failed;
    newRib.canUpdate = obj.canUpdate;
    newRib.canDelete = obj.canDelete;
    newRib.display = obj.display;
    newRib.notifDefType = obj.notifDefType;
    newRib.ownerType = obj.ownerType;
    newRib.ownerId = obj.ownerId;
    newRib.ownerLabel = obj.ownerLabel;
    return newRib;
  }

  public toJsonRib (): string {
    const json = {
      bankId: this.bankId,
      iban: this.iban,
      mandatId: this.mandatId,
      owner: this.owner,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromRib (obj: Rib): void {
    this.id = obj.id;
    this.bankId = obj.bankId;
    this.iban = obj.iban;
    this.mandatId = obj.mandatId;
    this.owner = obj.owner;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
    this.ownerType = obj.ownerType;
    this.ownerId = obj.ownerId;
    this.ownerLabel = obj.ownerLabel;
  }

  public compareRib (value: Rib): boolean {
    return (this.toJsonRib() == value.toJsonRib());
  }

  public cloneRib (): Rib {
    return Rib.fromJson(this);
  }

  public createForStoreRib (): Promise<Rib> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/ribs/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromRib(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public updateForStoreRib (): Promise<Rib> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/ribs/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromRib(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public deleteForStoreRib (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/ribs/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/ribs/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Ribs/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = Rib.fromJson(listData.reccords[0] as Rib);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<Rib> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Ribs/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = Rib.fromJson(listData.reccords[0] as Rib);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(ribs: Rib[]) {
  }
}
